import { Component, HostListener, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { HttpStatusCode, ResponseModel } from 'src/app/Shared/model/response.model';
import { ITestmonial } from 'src/app/Shared/model/testmonial.model';
import { ApiDataService } from 'src/app/Shared/services/apidata.service';
import { AppService } from 'src/app/Shared/services/app.service';

@Component({
  selector: 'app-tesmonial-slider',
  templateUrl: './tesmonial-slider.component.html',
  styleUrls: ['./tesmonial-slider.component.scss']
})
export class TesmonialSliderComponent implements OnInit {
  testmonial?: ITestmonial[] = [];

  mobileview = false;
  slideConfig = {};
  currentLang = 'en';
  public subscriptions$: Subscription[] = [];

  constructor(private apiservice: ApiDataService, private appsetting: AppService,
    public translate: TranslateService,
     public appservice: AppService,

    ) {
  }

  ngOnInit(): void {
    this.getTestmonialList();
    this.mobileview = (window.innerWidth < 600);
    this.slideConfig = this.appsetting.getSliderConfig(3, this.mobileview);
    this.subscriptions$.push(
      //------------Subscribe languege change---------------------
      this.appservice.getcurrentLanguage().subscribe((locale) => {
        this.currentLang = locale;
        localStorage.setItem('locale', locale);
      })
    );

    this.currentLang = this.appservice.getSavecurrentLanguage();
  }

  getTestmonialList() {
    const url = `Testimonial/GetAllActiveTestimonialList?PageSize=0&PageNumber=0`;
    this.apiservice.getData(url).subscribe
      ((response: ResponseModel<any>) => {
        if (response.status === HttpStatusCode.OK) {
          this.testmonial = response.data.testimonials;
        }
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.mobileview = (window.innerWidth < 600);
    this.slideConfig = this.appsetting.getSliderConfig(4, this.mobileview);
  }

}
